// Firebase client SDK: shared `app` + Auth + Google OAuth provider for the browser.
// All Firestore reads/writes use `getV3Db()` in `@/lib/v3/db.ts` (database `v3db`).
// Named client-db.ts to avoid webpack externals matching "firebase" in path
// (Firebase App Hosting adapter externalizes modules with "firebase" in path)
"use client";

import { app } from "./firebase-app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

let authInstance: ReturnType<typeof getAuth> | null = null;

const initAuth = () => {
  if (typeof window === "undefined") {
    return {
      currentUser: null,
      onAuthStateChanged: () => () => {},
    } as unknown as ReturnType<typeof getAuth>;
  }
  if (!authInstance) {
    authInstance = getAuth(app);
  }
  return authInstance;
};

const auth = initAuth();

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Separate provider for incremental calendar authorization —
// only used when the user explicitly opts into Google Calendar sync.
const calendarGoogleProvider = new GoogleAuthProvider();
calendarGoogleProvider.addScope("https://www.googleapis.com/auth/calendar");
calendarGoogleProvider.setCustomParameters({
  prompt: "consent",
  include_granted_scopes: "true",
});

export { app, auth, googleProvider, calendarGoogleProvider };
